<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewResponse"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchResponses"
        @resetFilters="resetFilters"
        @removeItem="removeResponse"
        @removeSelectedItems="removeResponses"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="responseList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveResponse" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Inquiry_Responses',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Response Details');
        const addButtonLabel = ref('New Response');
        const addingRight = ref('Adding Inquiry Responses');
        const removingRight = ref('Deleting Inquiry Responses');
        const rightsModule = ref('CRM');
        const idField = 'response_id';
        const inquiryID = ref('');
        const agentComponentKey = ref(0);
        const inquiryArray = computed(() => store.state.Customer_Inquiries.inquiryArr);
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const responseList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Inquiry_Responses.isEditing)
        const selectedInquiry = computed(()=> store.state.Inquiry_Responses.selectedInquiry);
        const selectedResponse = computed(()=> store.state.Inquiry_Responses.selectedResponse);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "created_at"},
            {label: "Client Name", key: "customer_name"},
            {label: "Email", key: "customer_email"},
            {label: "Subject", key: "subject"},
            {label: "Message", key: "message", maxWidth:"700px"},
            {label: "Responder", key: "responder"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Response', rightName: 'Editing Inquiry Responses'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Response', rightName: 'Deleting Inquiry Responses'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const customer_name = ref('');
        const subject_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: customer_name, width:48},
            {type:'text', placeholder:"Search Subject...", value: subject_search, width:48},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchCustomerInquiries = async() =>{
            await store.dispatch('Customer_Inquiries/fetchCustomerInquiries', {company:companyID.value})
        };
        const handleSelectedInquiry = async(option) =>{
            await store.dispatch('Customer_Inquiries/handleSelectedInquiry', option)
            inquiryID.value = store.state.Customer_Inquiries.inquiryID;
            if(selectedInquiry.value && selectedResponse.value){
                selectedInquiry.value.inquiry.inquiry_id = inquiryID.value;
            }
        }
        const clearSelectedInquiry = async() =>{
            await store.dispatch('Customer_Inquiries/updateState', {inquiryID: ''});
            inquiryID.value = store.state.Customer_Inquiries.inquiryID;
        }
        const inquiryValue = computed(() => {
           return (selectedResponse.value && selectedResponse.value.inquiry && !inquiryID.value) ? selectedResponse.value.inquiry.inquiry_id : inquiryID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Customer Inquiry", value: inquiryValue.value, componentKey: agentComponentKey,
                    selectOptions: inquiryArray, optionSelected: handleSelectedInquiry, required: true,
                    searchPlaceholder: 'Select Inquiry...', dropdownWidth: '500px', updateValue: selectedInquiry.value,
                    clearSearch: clearSelectedInquiry
                },
                { type: 'text-area', name: 'message',label: "Message", value: selectedResponse.value?.message || '', textarea_rows: '3', textarea_cols: '56', required: true },
            ];
        };
        watch([selectedInquiry,selectedResponse], () => {
            if(selectedInquiry.value && selectedResponse.value){
                agentComponentKey.value += 1;
                updateFormFields();
            }else if(selectedResponse.value){
                updateFormFields();
            }
         }, { immediate: true });
        const addNewResponse = () =>{
            updateFormFields();
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Inquiry_Responses/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const responseID = row[idField];
                let formData = {
                    company: companyID.value,
                    response: responseID
                }
                await store.dispatch('Inquiry_Responses/fetchInquiryResponse',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const responseID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    response: responseID
                }
                await store.dispatch('Inquiry_Responses/deleteInquiryResponse',formData).
                then(()=>{
                    searchResponses();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            inquiryID.value = '';
            agentComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createInquiryResponse = async() =>{
            showModalLoader();
            let formData = {
                responder: userID.value,
                responder_id: userID.value,
                message: formFields.value[1].value,
                inquiry: inquiryID.value,
                inquiry_id: inquiryID.value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else if(inquiryValue.value == ''){
                toast.error('Please Select A Customer Inquiry');
                hideModalLoader();

            }else{
                try {
                    const response = await store.dispatch('Inquiry_Responses/createInquiryResponse', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Response created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Response.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Response: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchResponses();
                }
            }

        }
        const updateInquiryResponse = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                responder: userID.value,
                responder_id: userID.value,
                message: formFields.value[1].value,
                inquiry: inquiryValue.value,
                inquiry_id: inquiryValue.value,
                company: companyID.value,
                response: selectedInquiry.value.response_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else if(inquiryValue.value == ''){
                toast.error('Please Select A Customer Inquiry');
            }else{
                try {
                    const response = await store.dispatch('Inquiry_Responses/updateInquiryResponse', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Response updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Response.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Response: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchResponses();
                }
            }
        }
        const saveResponse = () =>{
            if(isEditing.value == true){
                updateInquiryResponse();
            }else{
                createInquiryResponse();
            }
        }
        const removeResponse = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    response: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Inquiry_Responses/deleteInquiryResponse',formData)
                    if(response && response.status == 200){
                        toast.success("Response Removed Succesfully");
                        searchResponses();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Response: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Response") 
            }else{
                toast.error("Please Select A Response To Remove")
            }
        }
        const removeResponses = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    response: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Inquiry_Responses/deleteInquiryResponse',formData)
                    if(response && response.status == 200){
                        toast.success("Response(s) Removed Succesfully");
                        searchResponses();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Response(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Response To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchResponses = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                customer_name: customer_name.value,
                subject: subject_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/inquiry-responses-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                responseList.value = response.data.results;
                store.commit('Inquiry_Responses/LIST_RESPONSES', responseList.value)
                depResults.value = response.data;
                depArrLen.value = responseList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchResponses();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchResponses();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchResponses();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchResponses();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchResponses(selectedValue.value);
        };
        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = async(option) =>{
        
        };
        const resetFilters = () =>{
            customer_name.value = '';
            subject_search.value = '';
            currentPage.value = 1;
            searchResponses();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchResponses();
            fetchCustomerInquiries();
        })
        return{
            title,idField, searchResponses, addButtonLabel, searchFilters, resetFilters, tableColumns, responseList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewResponse,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveResponse,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeResponse, removeResponses,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>